import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph, LandingSection} from '@tempo/landing';

export const FeatureTechnical: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['hifi']});

	return (
		<LandingSection
			position="relative"
			textAlign="center"
			justifyContent="flex-end"
			isContained
		>
			<LandingHeading width={{base: '100%', sm: '50%'}} as="h2">
				{t('Techniquement irréprochable')}
			</LandingHeading>
			<LandingParagraph
				width={{base: '100%', sm: '42%'}}
				dangerouslySetInnerHTML={{
					__html: t(
						'deezerhifilandingpage_text_hifisoundtechnicalexplanation_web',
					),
				}}
			/>
		</LandingSection>
	);
};
